import {useQueryClient, useMutation} from 'react-query'
import {useListView} from "../../core/ListViewProvider";
import {useQueryResponse} from "../../core/QueryResponseProvider";
import {deleteSelectedPosts} from "../../core/_requests";
import {QUERIES} from "../../../../../../_metronic/helpers";

const PageListGrouping = () => {
  const {selected, clearSelected} = useListView()
  const queryClient = useQueryClient()
  const {query} = useQueryResponse()

  const deleteSelectedItems = useMutation(() => deleteSelectedPosts(selected), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      clearSelected()
    },
  })

  return (
    <div className='d-flex justify-content-end align-items-center'>
      <div className='fw-bold me-5'>
        <span className='me-2'>{selected.length}</span> انتخاب شده
      </div>

      <button
        type='button'
        className='btn btn-danger'
        onClick={async () => await deleteSelectedItems.mutateAsync()}
      >
        پاک کردن انتخاب شده ها
      </button>
    </div>
  )
}

export {PageListGrouping}
